<template>
  <rui-menu-item :icon="currentTheme === 'dark' ? 'sun' : 'moon'"
                 :title="currentTheme === 'dark' ? $t('js.layout.switch_to_light_theme') : $t('js.layout.switch_to_dark_theme')"
                 @click="() => {changeTheme()}" />
</template>

<script>
import RuiMenuItem from '@experiments-labs/rise_ui/src/components/Menu/MenuItem.vue'

/**
 * Button to switch the theme, meant to be used in a `RuiNavbar`.
 *
 * Preference is stored in local storage.
 */
export default {
  name: 'GpThemeSwitcherMenuItem',
  components: { RuiMenuItem },
  data () {
    return {
      theme: null,
      browserTheme: window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',
    }
  },
  computed: {
    currentTheme () {
      return this.theme || this.browserTheme
    },
  },
  methods: {
    changeTheme (theme = null) {
      this.theme = theme || (this.currentTheme === 'dark' ? 'light' : 'dark')
      if (this.theme === null) {
        localStorage.removeItem('theme')
        return
      }
      localStorage.setItem('theme', this.theme)
      document.querySelector('body').classList.remove('rui-theme--light', 'rui-theme--dark')
      document.querySelector('body').classList.add(`rui-theme--${this.theme}`)
    },
  },
  created () {
    const theme = localStorage.getItem('theme')
    if (theme && ['dark', 'light'].includes(theme)) {
      this.theme = theme
      this.changeTheme(this.theme)
    }
  },
}
</script>
